import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var Paragraph = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, customisedCls = props.prefixCls, otherProps = __rest(props, ["className", "children", "prefixCls"]);
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('typography', configContext.prefixCls, customisedCls);
    var cls = classNames(className, prefixCls);
    return (React.createElement("p", __assign({ ref: ref, className: cls }, otherProps), children));
});
Paragraph.displayName = 'Paragraph';
export default Paragraph;
//# sourceMappingURL=paragraph.js.map